import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-end w-full"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-12px font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "h-full items-center flex"
}
const _hoisted_5 = { class: "flex flex-col justify-start leading-tight" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-start max-w-max"
}
const _hoisted_7 = {
  key: 1,
  class: "font-bold text-20px text-black-lp-300"
}
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "text-12px text-gray-lp-800" }
const _hoisted_10 = { class: "h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_DashboardOptions = _resolveComponent("DashboardOptions")!

  return (_openBlock(), _createBlock("div", {
    class: 
      `flex flex-col ${_ctx.border} ${_ctx.backgroundColor} ${_ctx.borderColor} ${_ctx.rounded}`
    
  }, [
    (_ctx.startDate && _ctx.endDate)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", {
            class: 
          `flex flex-row items-center space-x-2 max-w-max py-1 px-2 text-12px bg-gray-lp-700 text-red-lp-400 ${_ctx.styleTimer}`
        
          }, [
            _createVNode(_component_Icons, {
              name: "timer",
              class: "h-4"
            }),
            (_ctx.isCountdown)
              ? (_openBlock(), _createBlock("h3", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dashboard.console.card.remainingTime")) + " ", 1),
                  _createVNode("span", {
                    class: `${_ctx.isTimeZero ? '' : 'font-bold'}`
                  }, _toDisplayString(_ctx.timer), 3)
                ]))
              : _createCommentVNode("", true),
            _createVNode("h3", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.console.card.maxTime")) + " ", 1),
              _createVNode("span", {
                class: { 'font-bold': _ctx.maxTime }
              }, _toDisplayString(!_ctx.loading && _ctx.maxTime ? _ctx.maxTime : "-- : --"), 3)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: `flex flex-row px-6 space-x-4 leading-tight`,
      style: 
        `${
          _ctx.startDate && _ctx.endDate
            ? 'padding-bottom: 15px;'
            : 'padding-bottom: 15px; padding-top: 15px;'
        }`
      
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              class: `${_ctx.backgroundColorIcon} rounded-full p-3 flex max-w-max`
            }, [
              _createVNode(_component_Icons, {
                name: _ctx.icon,
                class: "text-white h-5",
                fill: ""
              }, null, 8, ["name"])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock("p", _hoisted_6, [
              _createVNode(_component_Spinner, {
                class: "loader",
                style: {"height":"35px"},
                color: "#EBECF0"
              })
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.formatPriceWithoutCurrency(_ctx.totalStt)), 1)),
        _createVNode("div", _hoisted_8, [
          _createVNode("p", _hoisted_9, _toDisplayString(_ctx.title), 1),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DashboardOptions, {
              data: _ctx.data,
              disabled: !_ctx.totalStt
            }, null, 8, ["data", "disabled"])
          ])
        ])
      ])
    ], 4)
  ], 2))
}